import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrderItem {
  product: {
    id: number;
    name: string;
    image_url?: string;
  };
}

interface Order {
  id: number;
  paymentMethod: string;
  order_items: OrderItem[];
  // ... other order fields
}

interface OrdersState {
  items: Order[];
}

const initialState: OrdersState = {
  items: []
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    addOrder: (state, action: PayloadAction<Order>) => {
      state.items.push(action.payload);
    }
  }
});

export const { addOrder } = ordersSlice.actions;
export default ordersSlice.reducer; 